import type { DirectiveBinding, VNode } from 'vue';

type Binding = DirectiveBinding<{ text: string; class: string }>;

function replace(el: HTMLElement, binding: Binding, vnode: VNode): void {
  if (!binding.value) {
    return;
  }

  if (!vnode.children || !Array.isArray(vnode.children)) {
    return;
  }

  const child = vnode.children[0];

  if (!child || typeof child !== 'object') {
    return;
  }

  let value: string | null = null;

  if ('text' in child) {
    value = child.text as string;
  }
  else if ('children' in child) {
    value = child.children as string;
  }

  if (!value) {
    return;
  }

  const escaped = escape(value);

  if (!escaped) {
    return;
  }

  el.innerHTML = escaped.replace(
    new RegExp(regExpEscape(binding.value.text), 'gi'),
    `<span class="${binding.value.class}">$&</span>`,
  );
}

export const highlight = {
  beforeMount: replace,
  updated: replace,
};

function escape(html: string): string {
  return typeof html === 'string'
    ? html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    : html;
}

function regExpEscape(str: string): string {
  return str.replace(/[/\\^$*+?.()|[\]{}]/g, '\\$&');
}
